import { swRequest } from "@sourcewhale/shared/src/svelte/api/sw-request";

export const queryCandidates = (body) =>
  swRequest({ path: "/api/candidates/query", method: "POST", body });

export const getDashboardToDos = ({ campaignType, userId }) =>
  swRequest({
    path: "/api/dashboard/todos",
    method: "POST",
    body: { campaignType, userId },
  });
